import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { fmtSignedPct } from '@/lib/format';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export const TrendBadge = ({ value, invert = false, className = '', testid, tooltip }) => {
  let badge;
  if (value === null || value === undefined || isNaN(value)) {
    badge = (
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium bg-slate-50 text-slate-500 ring-1 ring-slate-200 ${className}`} data-testid={testid}>
        <Minus className="h-3 w-3" /> —
      </span>
    );
  } else {
    const positive = invert ? value < 0 : value > 0;
    const negative = invert ? value > 0 : value < 0;
    const cls = positive
      ? 'bg-emerald-50 text-emerald-700 ring-emerald-200'
      : negative
        ? 'bg-rose-50 text-rose-700 ring-rose-200'
        : 'bg-slate-50 text-slate-600 ring-slate-200';
    const Icon = value > 0 ? ArrowUpRight : value < 0 ? ArrowDownRight : Minus;
    badge = (
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 tabular ${cls} ${className}`} data-testid={testid}>
        <Icon className="h-3 w-3" />
        {fmtSignedPct(value)}
      </span>
    );
  }

  if (!tooltip) return badge;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help">{badge}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[16rem] text-center leading-snug" data-testid="trend-badge-tooltip">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
